import React, { useState, useEffect } from 'react';
import { Badge, ModalHeader, ModalBody, Button, Label } from 'reactstrap';
import '../../../components/PaginatedTable/PaginatedTable.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './KnowledgeBaseContentViewModal.scss';
import { faBookmark, faDownload, faFile, faLink } from '@fortawesome/free-solid-svg-icons';
import { KNOWLEDGE_BASE_TYPES } from '../../../utils/knowledgeBaseConstants';
import createNotification from '../../../utils/createNotification';
import Helpers from '../../../utils/helper';
import bookmarkBorder from '../../../assets/images/bookmark-regular.svg';
import { USER_ROLES } from '../../../utils/constants';
import Rodal from '../../../components/Rodal/Rodal';
import { ASSOCIATE_MEMBER_RIGHTS_ENUM } from '../../../utils/associateMembersConstants';
import { useStateSelector } from '../../../store/selectors';
import KnowledgeBaseContentAccessPaymentComponent from './PurchaseAccess/KnowledgeBaseContentAccessPaymentComponent';
import { PaymentsHelper } from '../../../utils/paymentsHelper';
import { Tooltip } from 'react-tooltip';
import { NumberEncodingService } from '../../../utils/numberEncodingService';
import { KnowledgeBaseAttachmentType } from '../../KnowledgeBase/Models/Enums/KnowledgeBaseAttachmentType.enum';
import VideoPlayerPopup from '../../../containers/VideoPlayerPopup/VideoPlayerPopup';
import AudioPlayerPopup from '../../../containers/AudioPlayerPopup/AudioPlayerPopup';

const KnowledgeBaseContentViewModal = (props) => {
    const [fileIcon, setFileIcon] = useState(faFile);
    const [selectedContent, setSelectedContent] = useState(null);
    const [isUserHasAccess, setIsUserHasAccess] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isDisableKbContent, setIsDisableKbContent] = useState(
        props.isDisableKbContent === true
    );
    const [isPurchasing, setIsPurchasing] = useState(false);
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const [contentUrl, setContentUrl] = useState(null);
    const [contentIsHls, setContentIsHls] = useState(false);
    const [contentDownloadUrl, setContentDownloadUrl] = useState(null);
    const [isVideoPopupVisible, setIsVideoPopupVisible] = useState(false);
    const [isAudioPopupVisible, setIsAudioPopupVisible] = useState(false);


    useEffect(() => {
        const loggedInUserSummary = localStorage.getItem('loggedInUserSummary');
        const summary = JSON.parse(loggedInUserSummary);
        const isUserAdmin = summary.roleId === USER_ROLES.ADMIN;
        const isContentAvailable =
            summary.roleId === USER_ROLES.PRACTICE_OWNER ||
            summary.roleId === USER_ROLES.USER ||
            (summary.roleId === USER_ROLES.PRACTICE_SECONDARY_USER &&
                summary.associateMember &&
                summary.associateMember.some((x) =>
                    x.practices.some((p) =>
                        p.acceptedAccessRights.includes(
                            ASSOCIATE_MEMBER_RIGHTS_ENUM.KnowledgeBase
                        )
                    )
                ));

        setIsAdmin(isUserAdmin);
        const userHasAccess = isContentAvailable && !isDisableKbContent;
        setIsUserHasAccess(userHasAccess);
        setSelectedContent(props.data);
        if (isContentAvailable && !isDisableKbContent) {
            addToViewed();
        }
        const icon = KNOWLEDGE_BASE_TYPES.find(
            (k) => k.id == props.data.type
        ).icon;
        setFileIcon(icon);
    }, []);

    const axios = useStateSelector((state) => state.core.axios);

    useEffect(() => {
        if (window.location.pathname === '/knowledge-library') {
            const encodedId = NumberEncodingService.encode(props.data.id);
            const urlParams = new URLSearchParams(window.location.search);
            urlParams.set('contentId', encodedId);
            const newUrl = `${
                window.location.pathname
            }?${urlParams.toString()}`;
            window.history.replaceState(null, '', newUrl);
        }

        return () => {
            if (window.location.pathname === '/knowledge-library') {
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.delete('contentId');
                const newUrl = `${
                    window.location.pathname
                }?${urlParams.toString()}`;
                window.history.replaceState(null, '', newUrl);
            }
        };
    }, [props.data.id]);

    const addToViewed = () => {
        if (isUserHasAccess) {
            axios
                .post('/api/KnowledgeBase/add-to-viewed', {
                    contentId: props.data.id,
                })
                .then()
                .catch((error) => {
                    createNotification(error.message, 'error');
                });
        }
    };

    const openMediaPopup = () => {
        if (!selectedContent) return;

        const isNonDownloadableVideo = selectedContent.type == KnowledgeBaseAttachmentType.NonDownloadableVideo;
        const isNonDownloadableAudio = selectedContent.type == KnowledgeBaseAttachmentType.NonDownloadableAudio;
        const isVideo = selectedContent.type == KnowledgeBaseAttachmentType.Video;

        if (!contentUrl) {
            axios
                .get(`/api/KnowledgeBase/${selectedContent.id}/content`)
                .then((response) => {
                    if (
                        Helpers.isResponseSuccessful(
                            response,
                            'An error occured while fetching the Knowledge Library Content.'
                        )
                    ) {
                        setContentUrl(response.data.data.url);
                        setContentIsHls(response.data.data.isHls);
                        setContentDownloadUrl(response.data.data.downloadUrl ?? null);
                        if (isNonDownloadableVideo || isVideo) {
                            setIsVideoPopupVisible(true);
                        } else if (isNonDownloadableAudio) {
                            setIsAudioPopupVisible(true);
                        }
                    }
                })
                .catch((error) => {
                    createNotification(error.message, 'error');
                });
        } else {
            if (isNonDownloadableVideo || isVideo) {
                setIsVideoPopupVisible(true);
            } else if (isNonDownloadableAudio) {
                setIsAudioPopupVisible(true);
            }
        }
    };

    const openAttachment = (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        
        if (!selectedContent) return;
        
        const isNonDownloadableVideo = selectedContent.type == KnowledgeBaseAttachmentType.NonDownloadableVideo;
        const isNonDownloadableAudio = selectedContent.type == KnowledgeBaseAttachmentType.NonDownloadableAudio;
        const isVideo = selectedContent.type == KnowledgeBaseAttachmentType.Video;

        if (isNonDownloadableVideo || isNonDownloadableAudio || isVideo) {
            if (isUserHasAccess || isAdmin) {
                openMediaPopup();
            }
            return;
        }

        if (isUserHasAccess || isAdmin) {
            if (selectedContent.type == 7) {
                window.open(selectedContent.link, '_blank');
                return;
            }

            axios
                .get(`/api/KnowledgeBase/${selectedContent.id}/content`)
                .then((response) => {
                    if (
                        Helpers.isResponseSuccessful(
                            response,
                            'An error occured while fetching the Knowledge Library Content.'
                        )
                    ) {
                        window.open(response.data.data.url, '_blank');
                    }
                })
                .catch((error) => {
                    createNotification(error.message, 'error');
                });
        }
    };

    const updateContentState = () => {
        if (isUserHasAccess) {
            const updatedContent = { ...selectedContent };
            updatedContent.isAddedToShelf = !updatedContent.isAddedToShelf;
            setSelectedContent(updatedContent);
            props.updateMyShelf(selectedContent);
        }
    };

    const purchaseAccess = () => {
        setIsPurchasing(true);
    };

    const copyLinkToClipboard = () => {
        const encodedId = NumberEncodingService.encode(selectedContent.id);
        const link = `${window.location.origin}/knowledge-library?contentId=${encodedId}`;
        navigator.clipboard.writeText(link).then(() => {
            createNotification('Link copied to clipboard', 'success');
        });
    };

    return (
        <>
            {selectedContent ? (
                <>
                    <Rodal
                        visible={props.isVisible}
                        onClose={() => {
                            props.setIsVisible(false);
                        }}
                        animation={'fade'}
                        showMask={true}
                        className="modal-style content-view-modal announcement-modal view-modal-rodal">
                        <div className="editTitleHeader">
                            <div className="body_white_box associate_member">
                                <ModalHeader>
                                    <div>
                                        {selectedContent.title}
                                        <FontAwesomeIcon
                                            id="copyLinkIcon"
                                            icon={faLink}
                                            className="ml-2 cursor-pointer link-icon"
                                            onClick={copyLinkToClipboard}
                                        />
                                        <Tooltip
                                            place="top"
                                            anchorId="copyLinkIcon"
                                            className={
                                                'tooltip-content place-top'
                                            }>
                                            Copy link to the KL Content
                                        </Tooltip>
                                    </div>
                                </ModalHeader>
                            </div>

                            <ModalBody
                                className={`editTitleBody ${
                                    props.isDisableKbContent
                                        ? ' disabled-kl-content'
                                        : ''
                                }`}>
                                <div
                                    className="associate_form announcement_form"
                                    style={{ borderBottom: 0 }}>
                                    <div className="edit-title-image-div">
                                        <div className="edit-tags">
                                            {selectedContent.topics.map((t) => (
                                                <Badge>{t.tag}</Badge>
                                            ))}
                                        </div>
                                        <div className="edit-image-icon">
                                            {selectedContent.price ? (
                                                <Label>
                                                    Paid -{' '}
                                                    {Helpers.GetCurrencyFormatWithCents(
                                                        selectedContent.price
                                                    )}
                                                </Label>
                                            ) : (
                                                <Label>Free</Label>
                                            )}
                                            <FontAwesomeIcon
                                                icon={fileIcon}
                                                className={`file-icon ${
                                                    selectedContent.price &&
                                                    !selectedContent.isPurchased
                                                        ? ''
                                                        : 'cursor-pointer'
                                                }`}
                                                onClick={(e) => {
                                                    if (
                                                        !selectedContent.price ||
                                                        selectedContent.isPurchased
                                                    ) {
                                                        openAttachment(e);
                                                    }
                                                }}
                                            />
                                            {selectedContent.isAddedToShelf ? (
                                                <FontAwesomeIcon
                                                    icon={faBookmark}
                                                    className="file-icon cursor-pointer"
                                                    onClick={updateContentState}
                                                />
                                            ) : (
                                                <img
                                                    className={`file-icon ${
                                                        selectedContent.price &&
                                                        !selectedContent.isPurchased
                                                            ? ''
                                                            : 'cursor-pointer'
                                                    }`}
                                                    src={bookmarkBorder}
                                                    onClick={() => {
                                                        if (
                                                            !selectedContent.price ||
                                                            selectedContent.isPurchased
                                                        ) {
                                                            updateContentState();
                                                        }
                                                    }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                    <div className="edit-title-dec-wrapper">
                                        <label>Introduction</label>
                                        <div className="edit-title-intro-text-wrapper">
                                            <p className="deleteModalBodyP">
                                                {selectedContent.introText}
                                            </p>
                                        </div>
                                    </div>
                                    {selectedContent.price &&
                                    !selectedContent.isPurchased ? (
                                        <div className="purchase-btn-container">
                                            <Button
                                                className="btn save-btn"
                                                onClick={purchaseAccess}>
                                                Purchase
                                            </Button>
                                        </div>
                                    ) : (
                                        <div className="edit-title-dec-wrapper">
                                            <label>Source File</label>
                                            <div className="file-info-wrapper">
                                                <FontAwesomeIcon
                                                    icon={fileIcon}
                                                    className="file-icon  cursor-pointer"
                                                    onClick={(e) => {
                                                        openAttachment(e);
                                                    }}
                                                />
                                                <p
                                                    className="file-name cursor-pointer"
                                                    onClick={(e) => {
                                                        openAttachment(e);
                                                    }}>
                                                    {selectedContent.type == 7
                                                        ? props.isDisableKbContent
                                                            ? ' '
                                                            : selectedContent.link
                                                        : selectedContent.fileName}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </ModalBody>
                        </div>
                    </Rodal>
                    {isPurchasing ? (
                        <div className="absolute-container">
                            <KnowledgeBaseContentAccessPaymentComponent
                                isVisible={isPurchasing}
                                setIsVisible={setIsPurchasing}
                                content={selectedContent}
                                paymentSuccess={(transactionId) => {
                                    const onSuccess = () => {
                                        setSelectedContent({
                                            ...selectedContent,
                                            isPurchased: true,
                                        });
                                    };
                                    PaymentsHelper.waitForPaymentConfirmation(
                                        axios,
                                        setIsPurchasing,
                                        onSuccess,
                                        'Knowledge Library Content Payment received successfully',
                                        'Knowledge Library Content Payment Failed',
                                        transactionId
                                    );
                                }}></KnowledgeBaseContentAccessPaymentComponent>
                        </div>
                    ) : (
                        []
                    )}
                    {isVideoPopupVisible && contentUrl && selectedContent ? (
                        <VideoPlayerPopup
                            title={selectedContent.title}
                            src={contentUrl}
                            isHls={contentIsHls}
                            onClose={() => { setIsVideoPopupVisible(false); setContentDownloadUrl(null); }}
                            isRecordingEnabled={false}
                            hideContextMenu={
                                selectedContent.type == KnowledgeBaseAttachmentType.NonDownloadableVideo ||
                                selectedContent.type == KnowledgeBaseAttachmentType.NonDownloadableAudio
                            }
                            downloadUrl={selectedContent.type == KnowledgeBaseAttachmentType.Video ? contentDownloadUrl : undefined}
                        />
                    ) : null}
                    {isAudioPopupVisible && contentUrl && selectedContent ? (
                        <AudioPlayerPopup
                            title={selectedContent.title}
                            src={contentUrl}
                            onClose={() => setIsAudioPopupVisible(false)}
                            hideContextMenu={true}
                        />
                    ) : null}
                </>
            ) : (
                []
            )}
        </>
    );
};

export default KnowledgeBaseContentViewModal;
